import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CopyIcon } from 'static/ic-copy.svg';
import { isElectron } from '@web-chat-core/ui-kit/helpers/electron';
import { Tooltip } from '@web-chat-core/ui-kit';
import { selectEmbeddedInitialData } from '../../../../../state/selectors/app';
import { ShareButton, ShareLinkLayout, ShareTextField } from './view';

export const ShareLink = () => {
    const { t } = useTranslation();

    const roomName = selectEmbeddedInitialData()?.config.roomName;
    const link = isElectron ? `${process.env.REACT_APP_APP_URL}/call/${roomName}` : window.location.href;
    const [copied, setCopied] = useState(false);
    const [label, setLabel] = useState(t('web_call_tooltip_link'));

    const handleClick = () => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            setCopied(true);
            setLabel(t('web_call_some_link_copied'));
            setTimeout(() => {
                setLabel(t('web_call_tooltip_link'));
            }, 3000);

            return navigator.clipboard.writeText(link);
        }
    };

    const changeStateChange = useCallback((isOpen: boolean) => {
        if (isOpen) {
            setCopied(true);
        } else {
            setCopied(false);
        }
    }, []);

    return (
        <ShareLinkLayout>
            <ShareTextField
                type="text"
                value={link}
                placeholder={t('web_call_some_link')}
                withStaticLabel
                removeOuterWith
            />

            <Tooltip manuallyOpened={copied} label={label} onChange={changeStateChange}>
                <ShareButton onClick={handleClick}>
                    <CopyIcon />
                </ShareButton>
            </Tooltip>
        </ShareLinkLayout>
    );
};
